// import React, { useState } from "react";
// import { Modal, Button, Spinner, Alert } from "react-bootstrap";
// import api from "../../../api";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
// import { fetchReimbursement } from "./store/reimbursementSlice";

// const AddReimbursement = ({ show, onClose, userId }) => {
//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState("");
//   const [loading, setLoading] = useState(false); 
//   const [errorMessage, setErrorMessage] = useState(""); // State for error message
//   const dispatch = useDispatch();

//   const handleFileUpload = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       if (selectedFile.type === "text/csv" || selectedFile.name.endsWith(".csv")) {
//         setFile(selectedFile);
//         setFileName(selectedFile.name);
//         setErrorMessage(""); 
//       } else {
//         setFile(null);
//         setFileName("");
//         setErrorMessage("Only CSV files are allowed.");
//       }
//     }
//   };

//   const handleAddReimbursement = async () => {
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("reimbursement_sheet", file);
//     setLoading(true); 

//     try {
//       const response = await api.post("/add-reimbursement", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if(response.status === 200) {
//         toast.success(response.data.message);
//         onClose(); 
//         dispatch(fetchReimbursement());
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {      
//       toast.error("Error uploading file:");
//     } finally {
//       setLoading(false); 
//     }
//   };

//   const handleClose = () => {
//     setFile(null); 
//     setFileName(""); 
//     setErrorMessage(""); // Clear error message on close
//     onClose(); 
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Modal.Header>
//         <Modal.Title>{userId ? "Edit User" : "Add Reimbursement"}</Modal.Title>
//         <button
//           type="button"
//           onClick={handleClose}
//           aria-label="Close"
//           style={{
//             position: "absolute",
//             right: "1rem",
//             top: "0rem",
//             background: "none",
//             border: "none",
//             fontSize: "1.5rem",
//             color: "#000",
//             cursor: "pointer",
//           }}
//         >
//           &times;
//         </button>
//       </Modal.Header>

//       <Modal.Body>
//         <input
//           type="file"
//           accept=".csv"
//           onChange={handleFileUpload}
//           style={{ marginBottom: "1rem" }}
//         />
//         {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
//         {fileName && <p>Selected File: {fileName}</p>}

//         {file && (
//           <div className="d-flex justify-content-end">
//             {loading ? (
//               <Spinner animation="border" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </Spinner>
//             ) : (
//               <Button variant="primary" onClick={handleAddReimbursement}>
//                 Add
//               </Button>
//             )}
//           </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default AddReimbursement;

import React, { useState } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import api from "../../../api";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { fetchReimbursement } from "./store/reimbursementSlice";

const AddReimbursement = ({ show, onClose, userId }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false); 
  const dispatch = useDispatch();

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleAddReimbursement = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("reimbursement_sheet", file);
    setLoading(true); 

    try {
      const response = await api.post("/import-reimbursement", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if(response.status === 200) {
        toast.success(response.data.message);
        onClose(); 
        dispatch(fetchReimbursement());
      } else {
        toast.error(response.data.message);
      }
      
    } catch (error) {      
      toast.error("Error uploading file");
    } finally {
      setLoading(false); 
    }
  };

  const handleClose = () => {
    setFile(null); 
    setFileName(""); 
    onClose(); 
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>{userId ? "Edit Reimbursement" : "Add Reimbursement"}</Modal.Title>
        <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={handleClose}
        style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            background: "transparent",
            border: "none",
            fontSize: "1.25rem",
        }}
    >
        &times;
    </button>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formFile" className="mb-4">
          <Form.Label style={{ fontWeight: "500", fontSize: "1rem" }}>Upload Reimbursement Sheet</Form.Label>
          <Form.Control 
            type="file"
            accept=".csv"
            onChange={handleFileUpload}
          />
          {fileName && <small className="text-muted mt-2">Selected File: {fileName}</small>}
        </Form.Group>
        
        <div className="d-flex justify-content-end mt-3">
          {loading ? (
            <Button variant="primary" disabled>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              <span className="visually-hidden">Loading...</span>
            </Button>
          ) : (
            <Button variant="primary" onClick={handleAddReimbursement} disabled={!file}>
              {userId ? "Update" : "Add"} Reimbursement
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddReimbursement;
